import { namedOperations } from '../graphql/@generated/graphql';

export const queryKeys = namedOperations.Query;
